import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../../Router/all_routes";
import { Edit, Info, Trash2 } from "feather-icons-react/build/IconComponents";
import { useForm } from "react-hook-form";
import InputField from "../../../components/Input";
import BrandServices from "../../../../services/Brand";
import ProductServices from "../../../../services/Product";
import SelectField from "../../../components/Select";
import BayServices from "../../../../services/Bay";
import SectionServices from "../../../../services/Section";
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import Table from "../../../../core/pagination/datatable";
import { Popconfirm } from "antd";
import { v4 as uuidv4 } from 'uuid'
import { ErrorToaster } from "../../../components/toaster/Toaster";

const AdjustmentForm = ({ onSubmit, loading }) => {

  const route = all_routes;

  const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm();

  // *For Brands
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);

  // *For Bays
  const [bays, setBays] = useState([]);
  const [selectedBay, setSelectedBay] = useState(null);

  // *For Sections
  const [sections, setSections] = useState([]);
  const [selectedSection, setSelectedSection] = useState(null);

  // *For Products
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // *For Product Variants
  const [variants, setVariants] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);

  // *For Bulk Product Adjustment
  const [bulkProducts, setBulkProducts] = useState([]);

  // *For Row Index
  const [rowIndex, setRowIndex] = useState();

  // *For Get Brands
  const getBrands = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await BrandServices.getBrands(params)
      setBrands(data)
    } catch (error) {
      console.log('getBrands => error:', error)
    }
  }

  // *For Get Bays
  const getBays = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await BayServices.getBays(params)
      setBays(data)
    } catch (error) {
      console.log('geBays => error:', error)
    }
  }

  // *For Get Sections
  const getSections = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await SectionServices.getSections(params)
      setSections(data)
    } catch (error) {
      console.log('getSections => error:', error)
    }
  }

  // *For Get Products
  const getProducts = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true,
        brand: selectedBrand?.id
      }
      const { data } = await ProductServices.getProducts(params)
      setProducts(data)
    } catch (error) {
      console.log('getProducts => error:', error)
    }
  }

  // *For Add Bulk Product
  const addBulkProduct = async (formData) => {
    try {
      const isVariant = bulkProducts.some(e => e?.variant?.id === selectedVariant?.id)
      if (isVariant) {
        ErrorToaster('Product Variant already added')
        return
      }
      const spreadBulkProducts = [...bulkProducts]
      const obj = {
        id: uuidv4(),
        item: selectedProduct,
        brand: selectedBrand,
        variant: selectedVariant,
        bay: selectedBay,
        section: selectedSection,
        quantityChange: Number(formData?.quantity),
        reason: formData?.reason,
      }

      if (rowIndex != null) {
        spreadBulkProducts[rowIndex] = obj;
      } else {
        spreadBulkProducts.push(obj);
      }
      setBulkProducts(spreadBulkProducts)
      reset()
      setSelectedBrand(null)
      setSelectedProduct(null)
      setSelectedVariant(null)
      setSelectedBay(null)
      setSelectedSection(null)
    } catch (error) {
      console.log('submitForm => error:', error)
    }
  }

  // *For Edit Row
  const editRow = (updateData, index) => {
    try {
      setRowIndex(index)
      setValue('brand', updateData?.brand?.name)
      setValue('product', updateData?.item?.name)
      setValue('variant', updateData?.variant?.name)
      setValue('bay', updateData?.bay?.name)
      setValue('section', updateData?.section?.name)
      setValue('quantity', updateData?.quantityChange)
      setValue('reason', updateData?.reason)
      setSelectedBrand(updateData?.brand)
      setSelectedProduct(updateData?.item)
      setSelectedVariant(updateData?.variant)
      setSelectedBay(updateData?.bay)
      setSelectedSection(updateData?.section)
    } catch (error) {
      console.log('editRow => error:', error)
    }
  }

  // *For Delete Row
  const deleteRow = (id) => {
    try {
      const index = bulkProducts.findIndex((e) => e.id === id)
      let updateProductRow = [...bulkProducts]
      updateProductRow.splice(index, 1);
      setBulkProducts(updateProductRow)
    } catch (error) {
      console.log('deleteProductRow => error:', error)
    }
  }

  // *For Submit Form
  const submitForm = async (formData) => {
    try {
      if (bulkProducts.length === 0) {
        ErrorToaster('Please add at least one product')
        return
      }
      const bulkAdjustments = []
      bulkProducts.forEach(e => {
        bulkAdjustments.push({
          itemId: e?.item?.id,
          variantId: e?.variant?.id,
          bayId: e?.bay?.id,
          sectionId: e?.section?.id,
          quantityChange: e?.quantityChange,
          reason: e?.reason,
        })
      })
      const obj = {
        adjustments: bulkAdjustments
      }
      onSubmit(obj)
    } catch (error) {
      console.log('submitForm => error:', error)
    }
  }

  const columns = [
    {
      title: "Brand",
      dataIndex: "brand",
      render: (text) => (
        <span>
          {text?.name}
        </span>
      ),
    },
    {
      title: "Product",
      dataIndex: "item",
      render: (text) => (
        <span>
          {text?.name}
        </span>
      ),
    },
    {
      title: "Variant",
      dataIndex: "variant",
      render: (text) => (
        <span>
          {text?.name}
        </span>
      ),
    },
    {
      title: "Bay",
      dataIndex: "bay",
      render: (text) => (
        <span>
          {text?.name}
        </span>
      ),
    },
    {
      title: "Section",
      dataIndex: "section",
      render: (text) => (
        <span>
          {text?.name}
        </span>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "quantityChange",
      align: 'center',
      render: (text) => (
        <span>
          {text}
        </span>
      ),
    },
    {
      title: "Reason",
      dataIndex: "reason",
      render: (text) => (
        <span>
          {text}
        </span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (text, record, index) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>
            <Link className="me-2 p-2"
              to="#"
              onClick={() => editRow(record, index)}
            >
              <Edit className="feather-edit" />
            </Link>
            <Link className="confirm-text p-2">
              <Popconfirm title="Sure to delete?" onConfirm={() => deleteRow(record.id)}>
                <Trash2 className="feather-trash-2" />
              </Popconfirm>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getBrands()
    getBays()
    getSections()
  }, []);

  useEffect(() => {
    if (selectedBrand?.id) {
      getProducts()
    }
  }, [selectedBrand]);

  useEffect(() => {
    if (selectedProduct?.id) {
      const variant = []
      selectedProduct?.variants?.map((item) => {
        variant.push({
          id: item?.id,
          name: Object.values(item?.attributes).join('-'),
        })
      })
      setVariants(variant)
      setSelectedVariant(null)
    }
  }, [selectedProduct]);

  return (
    <form onSubmit={handleSubmit(submitForm)}>
      <div className="card">
        <div className="card-body add-product pb-0">
          <div className="mb-3">
            <div className="addproduct-icon">
              <h5>
                <Info className="add-info" />
                <span>Information</span>
              </h5>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="mb-3 add-product">
                  <SelectField
                    label={"Brand"}
                    options={brands}
                    selected={selectedBrand}
                    onSelect={(value) => setSelectedBrand(value)}
                    error={errors?.brand?.message}
                    register={register("brand", {
                      required: 'Please select brand.'
                    })}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="mb-3 add-product">
                  <SelectField
                    disabled={selectedBrand === null}
                    label={"Product"}
                    options={products}
                    selected={selectedProduct}
                    onSelect={(value) => setSelectedProduct(value)}
                    error={errors?.product?.message}
                    register={register("product", {
                      required: 'Please select product.',
                    })}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="mb-3 add-product">
                  <SelectField
                    disabled={selectedProduct === null}
                    label={"Variant"}
                    options={variants}
                    selected={selectedVariant}
                    onSelect={(value) => setSelectedVariant(value)}
                    error={errors?.variant?.message}
                    register={register("variant", {
                      required: 'Please select variant.'
                    })}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="mb-3 add-product">
                  <SelectField
                    label={"Bay"}
                    options={bays}
                    selected={selectedBay}
                    onSelect={(value) => setSelectedBay(value)}
                    error={errors?.bay?.message}
                    register={register("bay", {
                      required: 'Please select bay.'
                    })}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="mb-3 add-product">
                  <SelectField
                    label={"Section"}
                    options={sections}
                    selected={selectedSection}
                    onSelect={(value) => setSelectedSection(value)}
                    error={errors?.section?.message}
                    register={register("section", {
                      required: 'Please select section.'
                    })}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="mb-3 add-product">
                  <InputField
                    label="Quantity"
                    error={errors?.quantity?.message}
                    register={register("quantity", {
                      required: 'Please enter product quantity.',
                    })}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-sm-6 col-12">
                <div className="mb-3 add-product">
                  <InputField
                    label="Reason"
                    inputType="textarea"
                    placeholder="Type Reason"
                    register={register("reason", {
                      required: 'Please enter reason.'
                    })}
                  />
                </div>
              </div>
              <div className="col-lg-12 col-sm-6 col-12">
                <button
                  type="button"
                  className="btn btn-submit"
                  onClick={handleSubmit(addBulkProduct)}
                >
                  Add Product
                </button>
              </div>
            </div>
            {bulkProducts.length > 0 && (
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={bulkProducts}
                  isPagination={false}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="col-lg-12">
        <div className="btn-addproduct mb-4">
          <Link to={route.products} className="btn btn-cancel me-2">
            Cancel
          </Link>
          <button
            type="submit"
            className="btn btn-submit"
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default AdjustmentForm;
